import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-table-string-render',
  templateUrl: './table-string-render.component.html',
  styleUrls: ['./table-string-render.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableStringRenderComponent implements OnInit, ICellRendererAngularComp {
  data!: any;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {}

  agInit(params: ICellRendererParams): void {
    this.updateByParams(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateByParams(params);
    this.cdr.markForCheck();
    return true;
  }

  private updateByParams(params: ICellRendererParams) {
    this.data = params;
  }
}
